import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'

import { ai } from './telemetryService'

/**
 * This Component provides telemetry with Azure App Insights
 *
 * NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking that requires this to be a Class Component rather than a Functional Component
 * Demo app: https://github.com/Azure-Samples/application-insights-react-demo
 */
class TelemetryProvider extends Component {
  state = {
    initialized: false,
  }

  componentDidMount() {
    const { history } = this.props
    const { initialized } = this.state
    const AppInsightsInstrumentationKey = this.props.instrumentationKey // PUT YOUR KEY HERE
    if (process.env.VITE_ENABLE_TRACKING != 'true') {
      return
    }
    if (
      !Boolean(initialized) &&
      Boolean(AppInsightsInstrumentationKey) &&
      Boolean(history)
    ) {
      ai.initialize(AppInsightsInstrumentationKey, history)
      this.setState({ initialized: true })
    }

    this.props.after()
  }

  render() {
    const { children } = this.props
    return <Fragment>{children}</Fragment>
  }
}

export default withRouter(TelemetryProvider)
// export default withRouter(withAITracking(ai.reactPlugin, TelemetryProvider))
